type Hospital = {
  /** 病院ID */
  id: string;
  /** 病院名 */
  name: string;
};

/**
 * 病院IDから病院名を取得する
 */
export const getHospitalNames = (
  hospitalIDs: string[], 
  availableHospitals: Hospital[]
): string => {
  return availableHospitals
    .filter(hospital => hospitalIDs.includes(hospital.id))
    .map(hospital => hospital.name)
    .join(', ');
};